import { getChromeRuntime } from '../chrome/wrappers';
import {
  ChromeMessageType,
  ProcessUrlResponse,
  ProcessUrlResponseType,
} from '../types';
import { getVerdict } from '../navigation/verdict';
import { isBlockerPage } from '../navigation/blockingUtils';

/**
 * Listen for messages from content script to answer if it's necessary to hide the tab's content or not
 */
export const setupContentHiding = () => {
  getChromeRuntime().onMessage.addListener((message, sender, sendResponse) => {
    // Exclude other messages
    if (message.type !== ChromeMessageType.SHOULD_RESTORE_CONTENT) {
      return;
    }

    const tabUrl = sender.url;

    // Blocker pages are local UI rendered by the extension itself, so they
    // must never be hidden by the verdict-driven flow. Otherwise the
    // verdict for the blocker URL resolves to BLOCK_BY_* (because the
    // child is still over the rule), the content script never gets a
    // `restore: true`, and the blocker stays invisible until the
    // VERDICT_TIMEOUT_MS fallback fires (5s).
    if (tabUrl && isBlockerPage(tabUrl)) {
      sendResponse({ restore: true });
      return false;
    }

    // Get the verdict and send message to restore content if is allowed,
    // or otherwise, send message to keep it hidden.
    if (tabUrl) {
      getVerdict(tabUrl).then(processedVerdict => {
        if (shouldRestoreTab(processedVerdict.verdict)) {
          sendResponse({ restore: true });
        } else {
          sendResponse({ restore: false });
        }
      });
      return true; // Return true to wait for sending async response
    }

    sendResponse({ restore: true });
    return false; // Return false for sending synchronous response
  });
};

const shouldRestoreTab = (verdict: ProcessUrlResponse) =>
  verdict.type === ProcessUrlResponseType.ALLOW ||
  verdict.type === ProcessUrlResponseType.IGNORE;
